import { useSetActiveSidebarLink } from "@hooks"
import { ComingSoon } from "@components"

const EventSetup = () => {
  useSetActiveSidebarLink("EVENT_EDIT_SETUP")

  return <ComingSoon />
}

export default EventSetup
